import { Box, List, ListItem, Typography } from "@mui/material";
import type { FC } from "react";

export const LearningAndDevelopmentModalContent: FC = () => {
  return (
    <Box>
      <Typography fontWeight={700} variant="body2">
        Create learning content your people will actually complete.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Training shouldn’t live in long PDFs or one-off slide decks. With Learning & Development in
        ChangeEngine, you can turn the content you already have into structured, engaging learning
        experiences—without starting from scratch.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Use AI to:
        <List sx={{ listStyleType: "disc", pl: 4 }}>
          <ListItem sx={{ display: "list-item" }}>Turn documents into training modules</ListItem>
          <ListItem sx={{ display: "list-item" }}>
            Generate personalized learning paths by role or team
          </ListItem>
          <ListItem sx={{ display: "list-item" }}>
            Create mobile-friendly content people can access anywhere
          </ListItem>
        </List>
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Then deliver it all through ChangeEngine, track completion, and see what’s landing.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Whether you’re onboarding new hires, rolling out manager training, or supporting a change
        initiative, everything stays connected—from learning to communication to measurement.
      </Typography>
      <Typography fontWeight={700} sx={{ mt: 2 }} variant="body2">
        Build once. Deliver everywhere. Learn what works.
      </Typography>
    </Box>
  );
};
